import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "alert-wizard__header" }
const _hoisted_2 = { class: "alert-wizard__body" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { key: 1 }
const _hoisted_5 = { key: 2 }
const _hoisted_6 = { class: "alert-wizard__footer" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "alert-wizard__expander" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_NTabs = _resolveComponent("NTabs")!
  const _component_NButton = _resolveComponent("NButton")!
  const _component_NForm = _resolveComponent("NForm")!
  const _component_AlertRuleForm = _resolveComponent("AlertRuleForm")!
  const _component_FastCommentsForm = _resolveComponent("FastCommentsForm")!
  const _component_NModalWindow = _resolveComponent("NModalWindow")!

  return (_openBlock(), _createBlock(_component_NModalWindow, {
    "class-name": 'alert-wizard',
    "has-margins": false,
    layout: "",
    customSize: "90vw"
  }, {
    header: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_NTabs, {
          modelValue: _ctx.tab,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.tab) = $event)),
          items: _ctx.tabItems,
          "has-bottom-border": false
        }, null, 8, ["modelValue", "items"]),
        _createVNode(_component_NButton, {
          icon: "close",
          round: "",
          type: "secondary",
          onClick: _ctx.closeHandler,
          class: "n-modal-window__close-button"
        }, null, 8, ["onClick"])
      ])
    ]),
    content: _withCtx(() => [
      _createElementVNode("div", _hoisted_2, [
        (_ctx.formSchema)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _createVNode(_component_NForm, {
                ref: _ctx.setFormRef,
                model: _ctx.item,
                layout: _ctx.formSchema
              }, null, 8, ["model", "layout"])
            ]))
          : (_ctx.isAlertRulesSelected)
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                _createVNode(_component_AlertRuleForm, {
                  class: "alert-wizard__body-content",
                  modelValue: _ctx.item.filters,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.item.filters) = $event)),
                  autosync: true,
                  multiple: false,
                  sections: _ctx.filterSections
                }, null, 8, ["modelValue", "sections"])
              ]))
            : (_ctx.isFastCommentsSelected)
              ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                  _createVNode(_component_FastCommentsForm, {
                    ref: "fastCommentForm",
                    class: "alert-wizard__body-content",
                    modelValue: _ctx.item.quick_replies,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.item.quick_replies) = $event))
                  }, null, 8, ["modelValue"])
                ]))
              : _createCommentVNode("", true)
      ])
    ]),
    footer: _withCtx(() => [
      _createElementVNode("div", _hoisted_6, [
        (_ctx.isNextAvailable)
          ? (_openBlock(), _createBlock(_component_NButton, {
              key: 0,
              "suffix-icon": "arrow-right",
              onClick: _ctx.nextHandler
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('common.next')), 1)
              ]),
              _: 1
            }, 8, ["onClick"]))
          : _createCommentVNode("", true),
        _hoisted_7,
        _createVNode(_component_NButton, {
          type: _ctx.isNextAvailable ? 'secondary' : 'primary',
          disabled: !_ctx.isSaveAvailable,
          onClick: _ctx.saveHandler
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('common.save_and_close')), 1)
          ]),
          _: 1
        }, 8, ["type", "disabled", "onClick"])
      ])
    ]),
    _: 1
  }))
}